// extracted by mini-css-extract-plugin
module.exports = {"lia-pager":"ThreadedReplyListSection_lia-pager__nTJwX"};